/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Lista produktów w koszyku */
export interface CartProductDetailDto {
  /**
   * ID Produktu
   * @format int64
   * @example 1
   */
  productId: number;
  /**
   * Nazwa produktu
   * @example "Pakiet SMS"
   */
  name: string;
  /**
   * Cena pojedynczego produktu w groszach
   * @format int32
   * @example 1000
   */
  price: number;
  /**
   * Łączna cena produktu w groszach
   * @format int32
   * @example 1000
   */
  totalPrice: number;
  /**
   * Ilość produktu
   * @format int32
   * @example 1
   */
  quantity: number;
  /**
   * Kategoria produktu
   * @example "SMS"
   */
  category: CartProductDetailDtoCategoryEnum;
  /** Metadane produktu */
  productMeta?: CartProductMetaDto[];
}

/** Metadane produktu */
export interface CartProductMetaDto {
  /**
   * Klucz metadanych produktu
   * @example "SMS_BOUGHT"
   */
  metaKey: CartProductMetaDtoMetaKeyEnum;
  /**
   * Wartość metadanych produktu
   * @example "1"
   */
  metaValue: string;
  /**
   * Tytuł metadanych produktu
   * @example "Pakiet SMS"
   */
  title: string;
  /**
   * Opis metadanych produktu
   * @example "Pakiet SMS 1000 sztuk"
   */
  description?: string;
}

export interface AsaAttributionDto {
  /** @format int64 */
  org_id?: number;
  /** @format int64 */
  campaign_id?: number;
  /** @format int64 */
  adgroup_id?: number;
  /** @format int64 */
  keyword_id?: number;
  /** @format int64 */
  ad_id?: number;
  country_or_region?: string;
  conversion_type?: string;
  click_date?: string;
  impression_date?: string;
  claim_type?: string;
}

export interface EntitlementDto {
  active?: boolean;
  /** @format int64 */
  expires?: number;
  id?: string;
  product?: ProductDto;
  source?: string;
  /** @format int64 */
  started?: number;
}

export interface PriceDto {
  /** @format double */
  value?: number;
  currency?: string;
  /** @format double */
  value_usd?: number;
}

export interface ProductDto {
  subscription?: SubscriptionDto;
  product_id?: string;
}

export interface QonversionWebhookEventDto {
  /** @format int64 */
  time?: number;
  revenue?: RevenueDto;
  price?: PriceDto;
  transaction?: TransactionDto;
  properties?: Record<string, string>;
  environment?: string;
  platform?: string;
  ip?: string;
  country?: string;
  locale?: string;
  /** @format int32 */
  quantity?: number;
  entitlements?: EntitlementDto[];
  event_name?: string;
  user_id?: string;
  custom_user_id?: string;
  identity_id?: string;
  advertiser_id?: string;
  /** @format int64 */
  created_at?: number;
  product_id?: string;
  device_id?: string;
  app_version?: string;
  sdk_version?: string;
  old_product_id?: string;
  new_product_id?: string;
  subscription_group?: string;
  /** @format int64 */
  user_install_date?: number;
  project_name?: string;
  app_id?: string;
  /** @format int32 */
  subscription_renew_count?: number;
  asa_attribution?: AsaAttributionDto;
}

export interface RevenueDto {
  /** @format double */
  value?: number;
  currency?: string;
  /** @format double */
  value_usd?: number;
  /** @format int32 */
  is_proceed?: number;
  /** @format int32 */
  proceeds_rate?: number;
}

export interface SubscriptionDto {
  current_period_type?: string;
  renew_state?: string;
}

export interface TransactionDto {
  /** @format int64 */
  expires?: number;
  /** @format int64 */
  transaction_id?: number;
  /** @format int64 */
  original_transaction_id?: number;
  /** @format int64 */
  grace_period_expires?: number;
  /** @format int64 */
  transaction_date?: number;
}

export interface OrderRegisterDto {
  /** Id sesji */
  sessionId: string;
  /**
   * Kwota w groszach
   * @format int32
   */
  amount: number;
  /** Email */
  email: string;
  /** Opis zamówienia */
  description: string;
  /** Nazwa klienta */
  client: string;
  /** Adres klienta */
  address: string;
  /** Kod pocztowy klienta */
  zip: string;
  /** Miasto klienta */
  city: string;
  /** Numer telefonu klienta */
  phone: string;
}

export interface InvoiceDataDto {
  /**
   * Imię
   * @example "Jan"
   */
  firstName: string;
  /**
   * Nazwisko
   * @example "Kowalski"
   */
  lastName: string;
  /**
   * Nazwa firmy
   * @example "Inwestoro"
   */
  companyName?: string;
  /**
   * NIP firmy
   * @example "1234567890"
   */
  taxId?: string;
  /**
   * Numer telefonu
   * @example "+48123456789"
   */
  phoneNumber: string;
  /**
   * Ulica
   * @example "ul. Przykładowa 1"
   */
  street: string;
  /**
   * Miasto
   * @example "Warszawa"
   */
  city: string;
  /**
   * Kod pocztowy
   * @example "00-001"
   */
  postalCode: string;
}

export interface OrderCreatedDto {
  /**
   * Numer zamówienia
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  orderNumer: string;
  /**
   * Status zamówienia
   * @example "PENDING"
   */
  orderStatus: OrderCreatedDtoOrderStatusEnum;
  /**
   * Całkowita kwota zamówienia
   * @format double
   * @example 99.99
   */
  totalPrice: number;
}

export interface StatusDto {
  /**
   * Status zamówienia
   * @example "PENDING"
   */
  orderStatus: StatusDtoOrderStatusEnum;
  /**
   * Całkowita kwota zamówienia
   * @format int64
   * @example 9999
   */
  totalPrice: number;
}

export interface ProductDetailDto {
  /**
   * Id produktu
   * @format int64
   * @example 1
   */
  productId: number;
  /**
   * Nazwa produktu
   * @example "SMS"
   */
  name: string;
  /**
   * Cena produktu w groszach
   * @format int32
   * @example 100
   */
  price: number;
  /**
   * Kategoria produktu
   * @example "SMS"
   */
  category: ProductDetailDtoCategoryEnum;
  /**
   * Opis produktu
   * @example "Opis produktu"
   */
  description?: string;
}

export interface ProductBaseInfoDto {
  /**
   * Id produktu
   * @format int64
   * @example 1
   */
  productId: number;
  /**
   * Nazwa produktu
   * @example "SMS"
   */
  name: string;
  /**
   * Cena produktu w groszach
   * @format int32
   * @example 100
   */
  price: number;
  /**
   * Kategoria produktu
   * @example "SMS"
   */
  category: ProductBaseInfoDtoCategoryEnum;
}

/** Lista pozycji zamówienia */
export interface OrderItemDto {
  /**
   * Nazwa produktu
   * @example "SMS"
   */
  productName: string;
  /**
   * Ilość produktu
   * @format int32
   * @example 1
   */
  quantity: number;
  /**
   * Cena jednostkowa produktu
   * @format int32
   * @example 9999
   */
  price: number;
  /**
   * Całkowita cena produktu
   * @format int32
   * @example 9999
   */
  totalPrice: number;
}

export interface OrderListDto {
  /**
   * Status zamówienia
   * @example "PENDING"
   */
  orderStatus: OrderListDtoOrderStatusEnum;
  /**
   * Całkowita kwota zamówienia
   * @format int64
   * @example 9999
   */
  totalPrice: number;
  /**
   * Identyfikator zamówienia
   * @format uuid
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  orderNumber: string;
  /** Lista pozycji zamówienia */
  orderItems: OrderItemDto[];
}

export interface CartDetailDto {
  /**
   * ID Koszyka
   * @format int64
   * @example 1
   */
  cartId: number;
  /**
   * Całkowita cena
   * @format int32
   * @example 1000
   */
  totalPrice: number;
  /** Lista produktów w koszyku */
  items: CartProductDetailDto[];
}

/**
 * Kategoria produktu
 * @example "SMS"
 */
export enum CartProductDetailDtoCategoryEnum {
  SMS = "SMS",
  AI_TOKENS = "AI_TOKENS",
  SUBSCRIPTION = "SUBSCRIPTION",
}

/**
 * Klucz metadanych produktu
 * @example "SMS_BOUGHT"
 */
export enum CartProductMetaDtoMetaKeyEnum {
  SUBSCRIPTIONTIMEDAYS1 = "SUBSCRIPTION_TIME_DAYS_1",
  SUBSCRIPTIONTIMEDAYS14 = "SUBSCRIPTION_TIME_DAYS_14",
  SUBSCRIPTIONTIMEMONTHS1 = "SUBSCRIPTION_TIME_MONTHS_1",
  SUBSCRIPTIONTIMEMONTHS3 = "SUBSCRIPTION_TIME_MONTHS_3",
  SUBSCRIPTIONTIMEMONTHS6 = "SUBSCRIPTION_TIME_MONTHS_6",
  SUBSCRIPTIONTIMEYEARS1 = "SUBSCRIPTION_TIME_YEARS_1",
  SMSPACKAGE15 = "SMS_PACKAGE_15",
  SMSPACKAGE50 = "SMS_PACKAGE_50",
  SMSPACKAGE100 = "SMS_PACKAGE_100",
  SMSPACKAGE250 = "SMS_PACKAGE_250",
  SMS_BOUGHT = "SMS_BOUGHT",
  SMSBOUGHT100 = "SMS_BOUGHT_100",
  ACCESS_ADVERTISEMENTS = "ACCESS_ADVERTISEMENTS",
  ACCESS_AUCTION = "ACCESS_AUCTION",
  ACCESS_BAILIFF_NOTICE = "ACCESS_BAILIFF_NOTICE",
  ACCESS_COOPERATIVES = "ACCESS_COOPERATIVES",
  ACCESS_RENTS = "ACCESS_RENTS",
  ACCESS_ANALYSIS = "ACCESS_ANALYSIS",
  AITOKENS100000 = "AI_TOKENS_100000",
  AITOKENS500000 = "AI_TOKENS_500000",
  AITOKENS1000000 = "AI_TOKENS_1000000",
}

/**
 * Status zamówienia
 * @example "PENDING"
 */
export enum OrderCreatedDtoOrderStatusEnum {
  PENDING = "PENDING",
  REGISTERED = "REGISTERED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED",
  COMPLETED = "COMPLETED",
}

/**
 * Status zamówienia
 * @example "PENDING"
 */
export enum StatusDtoOrderStatusEnum {
  PENDING = "PENDING",
  REGISTERED = "REGISTERED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED",
  COMPLETED = "COMPLETED",
}

/**
 * Kategoria produktu
 * @example "SMS"
 */
export enum ProductDetailDtoCategoryEnum {
  SMS = "SMS",
  AI_TOKENS = "AI_TOKENS",
  SUBSCRIPTION = "SUBSCRIPTION",
}

/**
 * Kategoria produktu
 * @example "SMS"
 */
export enum ProductBaseInfoDtoCategoryEnum {
  SMS = "SMS",
  AI_TOKENS = "AI_TOKENS",
  SUBSCRIPTION = "SUBSCRIPTION",
}

/**
 * Status zamówienia
 * @example "PENDING"
 */
export enum OrderListDtoOrderStatusEnum {
  PENDING = "PENDING",
  REGISTERED = "REGISTERED",
  PAID = "PAID",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  EXPIRED = "EXPIRED",
  COMPLETED = "COMPLETED",
}

export enum MapQonversionUserParamsAppTypeEnum {
  IOS = "IOS",
  ANDROID = "ANDROID",
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "http://192.168.31.12:8080";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== "string" ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl http://192.168.31.12:8080
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  order = {
    /**
     * @description Przetwarza zamówienie bez płatności, dodaje produkty do konta użytkownika
     *
     * @tags Operacje związane z transakcją
     * @name PayFree
     * @summary Przetworzenie darmowego zamówienia
     * @request PUT:/order/transaction/pay/free
     * @secure
     */
    payFree: (
      query: {
        /** @format uuid */
        orderNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/order/transaction/pay/free`,
        method: "PUT",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Aktualizuje produkt w koszyku użytkownika. Jeśli produkt nie istnieje w koszyku, zostanie zwrócony błąd
     *
     * @tags Operacje związane z koszykiem
     * @name UpdateProductInCart
     * @summary Aktualizacja produktu w koszyku
     * @request PUT:/order/cart/item/update
     * @secure
     */
    updateProductInCart: (
      query: {
        /** @format int64 */
        productId: number;
        /**
         * @format int32
         * @min 1
         */
        quantity: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CartProductDetailDto, object>({
        path: `/order/cart/item/update`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Dodaje produkt do koszyka użytkownika. Dodanie tego samego produktu spowoduje aktualizację jego ilości w koszyku
     *
     * @tags Operacje związane z koszykiem
     * @name AddProductToCart
     * @summary Dodanie produktu do koszyka
     * @request PUT:/order/cart/item/add
     * @secure
     */
    addProductToCart: (
      query: {
        /** @format int64 */
        productId: number;
        /**
         * @format int32
         * @min 1
         */
        quantity: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<CartProductDetailDto, object>({
        path: `/order/cart/item/add`,
        method: "PUT",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Przetwarza status transakcji i weryfikuje ją
     *
     * @tags Operacje związane z transakcją
     * @name HandleStatus
     * @summary Obsługa statusu transakcji - TYLKO DLA PRZELEWY24
     * @request POST:/order/transaction/status
     * @secure
     */
    handleStatus: (data: Record<string, object>, params: RequestParams = {}) =>
      this.http.request<void, void>({
        path: `/order/transaction/status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Potwierdza płatność i aktualizuje status zamówienia przez Qonversion
     *
     * @tags Operacje związane z qonversion
     * @name HandleQonversionWebhook
     * @summary Potwierdzenie płatności przez Qonversion
     * @request POST:/order/transaction/qonversion/webhook
     * @secure
     */
    handleQonversionWebhook: (data: QonversionWebhookEventDto, params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/order/transaction/qonversion/webhook`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Mapuje użytkownika z Qonversion
     *
     * @tags Operacje związane z qonversion
     * @name MapQonversionUser
     * @summary Mapowanie użytkownika Qonversion
     * @request POST:/order/transaction/qonversion/token
     * @secure
     */
    mapQonversionUser: (
      query: {
        token: string;
        appType: MapQonversionUserParamsAppTypeEnum;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/order/transaction/qonversion/token`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Rejestruje zamówienie w systemie
     *
     * @tags Operacje związane z qonversion
     * @name RegisterPayment
     * @summary Rejestracja zamówienia w systemie
     * @request POST:/order/transaction/qonversion/register/payment
     * @secure
     */
    registerPayment: (
      query: {
        /** @format uuid */
        orderNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<OrderRegisterDto, object>({
        path: `/order/transaction/qonversion/register/payment`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description NIE UŻYWAĆ TYLKO DLA PRZELEWY24 - Dodanie produktów zamówienia do konta użytkownika po dokonaniu płatności
     *
     * @tags Operacje związane ze aktualizacją danych po zamówieniu
     * @name ProcessNewOrder
     * @summary NIE UŻYWAĆ, TYLKO DLA PRZELEWY24 - Dodanie produktów do konta
     * @request POST:/order/process/assign-products
     * @secure
     */
    processNewOrder: (
      query: {
        /** @format uuid */
        orderNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/order/process/assign-products`,
        method: "POST",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Przenosi wszystkie produkty z koszyka do zamówienia i usuwa koszyk
     *
     * @tags Operacje związane ze składaniem zamówień
     * @name CreateOrder
     * @summary Złożenie zamówienia
     * @request POST:/order/create
     * @secure
     */
    createOrder: (data: InvoiceDataDto, params: RequestParams = {}) =>
      this.http.request<OrderCreatedDto, object>({
        path: `/order/create`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Przetwarza zamówienie i przekierowuje do Przelewy24 w celu dokonania płatności
     *
     * @tags Operacje związane z transakcją
     * @name Pay
     * @summary Przetworzenie zamówienia przez Przelewy24
     * @request GET:/order/transaction/pay/przelewy24
     * @secure
     */
    pay: (
      query: {
        /** @format uuid */
        orderNumber: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/order/transaction/pay/przelewy24`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Pobiera produkty z koszyka użytkownika
     *
     * @tags order-test-controller
     * @name GetProductsFromCart
     * @summary Pobranie produktów z koszyka
     * @request GET:/order/test
     * @secure
     */
    getProductsFromCart: (
      query: {
        /** @format int64 */
        orderId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, any>({
        path: `/order/test`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Pobiera status zamówienia oraz całkowitą kwotę zamówienia
     *
     * @tags Operacje związane ze składaniem zamówień
     * @name GetOrderStatus
     * @summary Pobieranie statusu zamówienia
     * @request GET:/order/status
     * @secure
     */
    getOrderStatus: (
      query: {
        /** @format uuid */
        orderNumer: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<StatusDto, object>({
        path: `/order/status`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pobiera szczegóły produktu z bazy danych
     *
     * @tags Operacje związane z produkatami
     * @name GetProductDetails
     * @summary Pobranie szczegółów produktu
     * @request GET:/order/product/details
     * @secure
     */
    getProductDetails: (
      query: {
        /** @format int64 */
        productId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<ProductDetailDto, object>({
        path: `/order/product/details`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pobiera wszystkie dostępne produkty z bazy danych
     *
     * @tags Operacje związane z produkatami
     * @name GetAllProducts
     * @summary Pobranie wszystkich produktów
     * @request GET:/order/product/all
     * @secure
     */
    getAllProducts: (params: RequestParams = {}) =>
      this.http.request<ProductBaseInfoDto[], object>({
        path: `/order/product/all`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pobiera listę zamówień użytkownika
     *
     * @tags Operacje związane ze składaniem zamówień
     * @name GetOrderList
     * @summary Pobieranie listy zamówień
     * @request GET:/order/list
     * @secure
     */
    getOrderList: (params: RequestParams = {}) =>
      this.http.request<OrderListDto[], object>({
        path: `/order/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pobiera dane do faktury z ostatniego zamówienia użytkownika
     *
     * @tags Operacje związane ze składaniem zamówień
     * @name GetLastOrderInvoiceData
     * @summary Pobieranie informacji z ostatniej faktury
     * @request GET:/order/invoice/last-data
     * @secure
     */
    getLastOrderInvoiceData: (params: RequestParams = {}) =>
      this.http.request<InvoiceDataDto, object>({
        path: `/order/invoice/last-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Pobiera produkty z koszyka użytkownika
     *
     * @tags Operacje związane z koszykiem
     * @name GetProductsFromCart1
     * @summary Pobranie produktów z koszyka
     * @request GET:/order/cart/items
     * @secure
     */
    getProductsFromCart1: (params: RequestParams = {}) =>
      this.http.request<CartDetailDto, object>({
        path: `/order/cart/items`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Usuwa pojedynczy produkt z koszyka użytkownika
     *
     * @tags Operacje związane z koszykiem
     * @name DeleteProductFromCart
     * @summary Usunięcie produktu z koszyka
     * @request DELETE:/order/cart/item/delete
     * @secure
     */
    deleteProductFromCart: (
      query: {
        /** @format int64 */
        productId: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<object, object>({
        path: `/order/cart/item/delete`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * @description Czyści koszyk użytkownika, usuwając wszystkie produkty z niego
     *
     * @tags Operacje związane z koszykiem
     * @name DeleteCart
     * @summary Wyczyszczenie koszyka
     * @request DELETE:/order/cart/delete
     * @secure
     */
    deleteCart: (params: RequestParams = {}) =>
      this.http.request<object, object>({
        path: `/order/cart/delete`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
